<div class="overlay">
  <mat-progress-spinner color="primary"
                        mode="indeterminate"
                        diameter="70">
  </mat-progress-spinner>
</div>
